<template>
    <div ref="cardRecordViewDom">
        <div class="title-box">
            <div class="title-content" @click="changeView('receive')" :class="viewPart === 'receive' ? 'receive-view' : 'normal-view'">
                <span>名片收錄</span>
            </div>

            <div class="title-content" @click="changeView('send')" :class="viewPart === 'send' ? 'send-view' : 'normal-view'">
                <span>申請名片</span>
            </div>
        </div>

        <div class="content-part" :class="viewPart === 'receive' ? 'receive-content-view' : 'send-content-view'">
            <cardReceiveRecord v-show="viewPart === 'receive'" />

            <cardSendRecord v-show="viewPart === 'send'" />
        </div>
    </div>

</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed, toRef} from "vue";
    import cardReceiveRecord from "@/components/shopopee/record1/cardReceiveRecord"
    import cardSendRecord from "@/components/shopopee/record1/cardSendRecord"

    const { proxy } = getCurrentInstance();

    const width = ref(425)

    const viewPart = ref("receive")

    function changeView(view) {
        viewPart.value = view
    }

</script>

<style scoped>
    .title-box {
        display: flex;
        text-align: center;
    }

    .title-box .title-content {
        width: 50%;
        padding: 10px;
        font-size: 14px;
        font-weight: 600;
        transition: 0.5s all ease;
        border-top: 1px #DCDFE6 solid;
    }

    .content-part {
        transition: 0.5s all ease;
        padding: 15px;
        overflow: hidden;
    }

    .receive-view {
        background: #F56C6C;
        color: #fefefe;
    }

    .receive-content-view {
        background: #FAFAFA;
    }

    .send-view {
        color: #fefefe;
        background: #F56C6C;
    }

    .send-content-view {
        background: #FAFCFF;
    }

    .normal-view {
        background: #ffffff;
        color: #606266;
    }
</style>